import {
  ImageFallbackType,
  setFallbackImage,
} from "../../../../components/image/imageWithFallback.shared";

export const CategoryImage = ({
  imageUrl,
  fallback,
}: {
  imageUrl: string;
  fallback?: ImageFallbackType;
}) => {
  const image = setFallbackImage({ img: imageUrl, fallback: fallback });
  return (
    <div className={"aspect-16/9"}>
      <img
        alt={"category image"}
        src={`${image}?w=1200&auto=compress`}
        className={"h-full w-full rounded-sm object-cover"}
      />
    </div>
  );
};
